if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initHoverArrowAnimation);
} else {
  initHoverArrowAnimation();
}

export function initHoverArrowAnimation() {
  const containers = document.querySelectorAll('[data-position-related-container]');

  containers.forEach((container) => {
    const button = container.querySelector('[data-position-related-button]');
    if (!button) return;

    if (!button.querySelector('.hover-circle')) {
      const span = document.createElement('span');
      span.classList.add('hover-circle');

      if (button.classList.contains('position-button-text-variant')) {
        span.textContent = button.getAttribute('data-hover-text') || '';
      } 
      else if (button.classList.contains('media-link')) {
        span.innerHTML = `
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M10 14L6 10L7.0625 8.9375L9.25 11.125V4H10.75V11.125L12.9375 8.9375L14 10L10 14ZM5.49417 17C5.08139 17 4.72917 16.8531 4.4375 16.5594C4.14583 16.2656 4 15.9125 4 15.5V14H5.5V15.5H14.5V14H16V15.5C16 15.9125 15.8531 16.2656 15.5592 16.5594C15.2653 16.8531 14.9119 17 14.4992 17H5.49417Z" fill="currentColor"/>
        </svg>
        `;
      }
      else if (button.classList.contains('external-link')) {
        span.innerHTML = `
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M2 18C1.45 18 0.979167 17.8042 0.5875 17.4125C0.195833 17.0208 0 16.55 0 16L0 2C0 1.45 0.195833 0.979167 0.5875 0.5875C0.979167 0.195833 1.45 0 2 0L9 0V2L2 2L2 16L16 16V9H18L18 16C18 16.55 17.8042 17.0208 17.4125 17.4125C17.0208 17.8042 16.55 18 16 18L2 18ZM6.7 12.7L5.3 11.3L14.6 2L11 2V0L18 0V7L16 7L16 3.4L6.7 12.7Z" fill="currentColor"/>
        </svg>
        `;
      }
      else {
        span.innerHTML = `
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M3.5 8.75L9.625 8.75L7.4375 10.9375L8.5 12L12.5 8L8.5 4L7.4375 5.0625L9.625 7.25L3.5 7.25L3.5 8.75Z" fill="currentColor"/>
        </svg>
        `;
      }
      button.appendChild(span);
    }

    container.addEventListener('mouseenter', () => {
      button.setAttribute('data-hovering', 'true');
    });

    container.addEventListener('mousemove', (e) => {
      const rect = container.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;

      button.style.setProperty('--mouse-x', `${x}px`);
      button.style.setProperty('--mouse-y', `${y}px`);
    });

    container.addEventListener('mouseleave', () => {
      button.removeAttribute('data-hovering');
      button.style.removeProperty('--mouse-x');
      button.style.removeProperty('--mouse-y');
    });
  });
}

// Video play/pause
document.querySelectorAll("[data-video-wrapper]").forEach(wrapper => {
  const video = wrapper.querySelector("[data-video]");
  const toggleBtn = wrapper.querySelector("[data-video-toggle]");
  const overlay = wrapper.querySelector(".overlay");
  if (!video || !toggleBtn || !overlay) return;

  const playIcon = toggleBtn.querySelector("[data-play-icon]");
  const pauseIcon = toggleBtn.querySelector("[data-pause-icon]");

  function playVideo() {
    const paused = video.paused;
    overlay.style.display = paused ? "block" : "none";
    playIcon.classList.toggle("hidden", !paused);
    pauseIcon.classList.toggle("hidden", paused);
  }

  toggleBtn.addEventListener("click", e => {
    e.stopPropagation();
    video.paused ? video.play() : video.pause();
  });

  wrapper.addEventListener("click", () => {
    if (video.paused) video.play();
  });

  video.addEventListener("play", playVideo);
  video.addEventListener("pause", playVideo);

  playVideo();
});

// Text link animation for the links comming from RTE
document.querySelectorAll('.rich-text span.style-arrow-link').forEach(span => {

  if (!span.querySelector('.arrow')) {
    const arrowDiv = document.createElement('div');
    arrowDiv.className = 'arrow';
    span.appendChild(arrowDiv);
  }
});